﻿import React, { useState } from "react";
import {
  setHoveredWorkflow,
  selectHoveredWorkflow,
  selectAllWorkflows,
  selectWorkflowsLoaded,
} from "@/features/homepage/homeSlice";
import { setSelectedWorkflow, selectWorkflow } from "@/features/homepage/workflowManagerSessionSlice";
import "./WorkflowSummary.css";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid } from "@mui/material";
import WorkflowManagerCard from "./WorkflowManagerCard";
import LoadingBar from "@/components/shared/LoadingBar";

const WorkFlowSummary = () => {
  const dispatch = useDispatch();
  const selectedWorkflow = useSelector(selectWorkflow);
  const workflows = useSelector(selectAllWorkflows);
  const hoveredWorkflow = useSelector(selectHoveredWorkflow);
  const [loadingAnimationFinished, setLoadingAnimationFinished] =
    useState(false);
  const workflowsLoaded = useSelector(selectWorkflowsLoaded);

  const setWorkflow = (operationId) => {
    dispatch(setSelectedWorkflow({ selectedWorkflow: operationId }));

    // heap.io
    window.heap.track("Summary - Select Workflow");
  };

  const handleMouseEnter = (operationId) => {
    dispatch(setHoveredWorkflow({ hoveredWorkflow: operationId }));
  };

  const handleMouseLeave = () => {
    dispatch(setHoveredWorkflow({ hoveredWorkflow: 0 }));
  };

  const truncateCount = (count) => {
    const num = parseInt(count, 10);
    if (isNaN(num)) return count;
    if (num >= 1e15) return `${Math.floor(num / 1e15)}Q`;
    if (num >= 1e12) return `${Math.floor(num / 1e12)}T`;
    if (num >= 1e9) return `${Math.floor(num / 1e9)}B`;
    if (num >= 1e6) return `${Math.floor(num / 1e6)}M`;
    if (num >= 1e3) return `${Math.floor(num / 1e3)}K`;
    return count;
  };

  return (
    <>
      <Grid
        display="flex"
        justifyContent="space-around"
        direction="row"
        alignItems="center"
        className="summary-card-grid"
        container
      >
        {!loadingAnimationFinished ? (
          <LoadingBar
            isDataLoaded={workflowsLoaded}
            setFinishedAnimation={setLoadingAnimationFinished}
          />
        ) : (
          workflows?.map((data, i) => {
            return (
              <Grid
                item
                className={`workflow-summary-grid-item ${
                  hoveredWorkflow === data.OperationId ? "workflow-hovered" : ""
                }`}
                key={i}
                size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}
                onMouseEnter={() => handleMouseEnter(data.OperationId)}
                onMouseLeave={handleMouseLeave}
              >
                <WorkflowManagerCard
                  name={data.OperationName}
                  sourceConnections={data.SourceConnections.length}
                  targetConnections={data.TargetConnections.length}
                  sourceArtifact={data.SourceArtifact}
                  targetArtifact={data.TargetArtifact}
                  errors={truncateCount(data.Error)}
                  processing={truncateCount(data.Processing)}
                  notQueued={truncateCount(data.NotQueued)}
                  successful={truncateCount((parseInt(data.Successful, 10) || 0) + (parseInt(data.CompletedWithWarning, 10) || 0))}
                  operationId={data.OperationId}
                  total={truncateCount(data.Total)}
                  receivingType={data.ReceivingType}
                  onMouseEnter={() => handleMouseEnter(data.OperationId)}
                  onMouseLeave={handleMouseLeave}
                />
                <Button
                  onClick={() => setWorkflow(data.OperationId)}
                  className="btn-primary workflow-summary-btn "
                >
                  Manage Workflow
                </Button>
              </Grid>
            );
          })
        )}
      </Grid>
    </>
  );
};

export default WorkFlowSummary;
